// extracted by mini-css-extract-plugin
module.exports =  {"queueItemWrapper":"Op4nucLu","duplicateQueueItem":"LTTUMe0H","queueSuggestionItem":"uCqpylTt","mergeButton":"MjzDLgYK"};